import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { aiManagementApi } from '../../api/aiManagement.api';
import { PageHeader, StatCard, Spinner, Btn } from '../../components/ui/index';
import AnimatedBarChart from '../../components/charts/AnimatedBarChart';
import AnimatedDonutChart from '../../components/charts/AnimatedDonutChart';
import { toPersian } from '../../utils/persianNumber';
import { useAutoRefresh } from '../../hooks/useAutoRefresh';

export default function ManagerAIDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = (showSpinner = true) => {
    if (showSpinner) setLoading(true);
    return aiManagementApi.getAIPerformanceStats()
      .then(r => setStats(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useAutoRefresh(() => load(false), { intervalMs: 10000 });

  return (
    <div className="fade-in">
      <PageHeader title="داشبورد عملکرد هوش مصنوعی" subtitle="آمار پاسخ‌دهی و پذیرش پاسخ‌های تولیدشده توسط AI"
        action={
          <div style={{ display: 'flex', gap: 8 }}>
            <Link to="/ai/review"><Btn variant="secondary">بررسی پاسخ‌ها</Btn></Link>
            <Link to="/ai/dataset"><Btn variant="secondary">دیتاست آموزشی</Btn></Link>
            <Link to="/ai/statistics"><Btn variant="secondary">آمار تفصیلی</Btn></Link>
          </div>
        }
      />

      {loading ? <Spinner /> : !stats ? null : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 14, marginBottom: 24 }}>
            <StatCard label="درصد پاسخ AI" value={toPersian(stats.ai_percent)} suffix="%" color="#7c3aed" />
            <StatCard label="درصد پاسخ انسانی" value={toPersian(stats.human_percent)} suffix="%" color="#29AAE1" />
            <StatCard label="نرخ پذیرش AI" value={toPersian(stats.ai_acceptance_rate)} suffix="%" color="#059669" />
            <StatCard label="نرخ رد AI" value={toPersian(stats.ai_rejection_rate)} suffix="%" color="#dc2626" />
            <StatCard label="میانگین اطمینان" value={stats.avg_confidence != null ? toPersian(stats.avg_confidence) : '—'} suffix={stats.avg_confidence != null ? '%' : ''} color="#f59e0b" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20 }}>
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 20 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>پاسخ AI در برابر انسانی</h3>
              <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 10 }}>روی هر بخش کلیک کنید تا سهم دقیق آن مشخص شود</p>
              <AnimatedDonutChart
                data={[
                  { label: 'پاسخ AI', value: stats.ai_answered },
                  { label: 'پاسخ انسانی', value: stats.human_answered },
                ]}
                formatValue={(v) => toPersian(v)}
                size={190}
              />
            </div>

            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 20 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>روند استفاده از AI</h3>
              <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 10 }}>روی هر روز کلیک کنید تا عدد دقیق آن جدا نمایش داده شود</p>
              <AnimatedBarChart data={stats.trend} valueKey="ai_count" labelKey="date" formatValue={(v) => toPersian(v)} height={200} />
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 20 }}>
            <h3 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>عملکرد AI به تفکیک دپارتمان</h3>
            <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 10 }}>روی هر دپارتمان کلیک کنید تا برجسته شود</p>
            <AnimatedBarChart
              data={stats.by_department}
              valueKey="ai_percent"
              labelKey="department_name"
              formatValue={(v) => `${toPersian(v)}%`}
              height={220}
            />
          </div>
        </>
      )}
    </div>
  );
}
